"use client"

import { Suspense } from "react"
import Finance from "./index"

export default function FinanceWrapper(props: any) {
  return (
    <Suspense fallback={null}>
      <Finance {...props} />
    </Suspense>
  )
}
